import { createRoot } from "react-dom/client";
import App from "./App.tsx";
import "./index.css";
import { initSentry } from "./lib/sentry";
import { installGlobalErrorHandlers } from "./lib/globalErrorHandlers";

initSentry();
installGlobalErrorHandlers();

createRoot(document.getElementById("root")!).render(<App />);
